import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login', { replace: true });
      return;
    }

    const session_id = match[1];
    (async () => {
      try {
        const res = await api.post('/auth/google/session', { session_id });
        if (res.data.token) {
          localStorage.setItem('dd_token', res.data.token);
        }
        setUser(res.data.user);
        const role = res.data.user.role;
        const home = role === 'admin' || role === 'pm' ? '/admin'
          : role === 'customer' ? '/customer'
          : '/interpreter';
        // Clear hash
        window.history.replaceState(null, '', window.location.pathname);
        navigate(home, { replace: true });
      } catch (e) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Google auth failed', e);
        }
        navigate('/login', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
      <div className="text-slate-600">Anmeldung läuft...</div>
    </div>
  );
};

export default AuthCallback;
